import { h } from '@stencil/core';
import { ETabType, CircularProductTypes, scrollToComponent, join, store, setLinearProductData, ACTION_TYPES, getLocaleFromBody, tryParse } from '@pes-ui/utils';
import { MAX_RELATED_PRODUCTS_FOR_HALF_WIDTH_COLUMN } from './constants';
import { isBrowser, isMobile } from '../../../globals/utils';
import { getAvailabilityInfo, getApcCta } from '../../../globals/apc-cta/api';
import { availabilityUrl, formCtaUrl } from '../../../globals/apc-cta/utils';
import { observeIntersectionWithHeader, setStickyBarTab, setTabActive, } from '../../../globals/stickyBar.utils';
export class AssetBarAndRelatedProducts {
  constructor() {
    this.assetBarRef = null;
    this.relatedProductsRef = null;
    this.initialrequestData = {
      standard: { apcCta: null, productAvailabilityInfo: null },
      refurbished: { apcCta: null, productAvailabilityInfo: null },
    };
    this.assetBar = undefined;
    this._assetBar = undefined;
    this.productRelations = undefined;
    this._productRelations = undefined;
    this.productId = undefined;
    this._productId = undefined;
    this.tabTitle = 'Assets';
    this._tabTitle = undefined;
    this.localeCode = undefined;
    this._localeCode = undefined;
    this.apcCta = undefined;
    this.isAPCSite = undefined;
    this.apcCtaUrl = undefined;
    this.productAvailabilityInfo = undefined;
    this.isExternalConsumer = undefined;
    this.productRelationCustomConfig = undefined;
    this._productRelationCustomConfig = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  handleTabClicked(event) {
    const { type } = event.detail;
    switch (type) {
      case ETabType.DOCUMENTS:
        scrollToComponent(this.assetBarRef);
        break;
      case ETabType.COMPATIBLE_PRODUCTS:
        scrollToComponent(this.relatedProductsRef);
        break;
    }
  }
  observe() {
    if (this.relatedProductsCount > 0) {
      observeIntersectionWithHeader(this.relatedProductsRef, (entries) => {
        var _a;
        if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
          setTabActive({
            type: ETabType.COMPATIBLE_PRODUCTS,
            title: isMobile() ? this.productRelations.relatedProductsBlockLabel : this.tabTitle,
          });
          this.setTabActive.emit();
        }
      });
    }
    if (this.documentsCount > 0) {
      observeIntersectionWithHeader(this.assetBarRef, (entries) => {
        var _a;
        if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
          setTabActive({
            type: ETabType.DOCUMENTS,
            title: isMobile() ? this.assetBar.labels.title : this.tabTitle,
          });
          this.setTabActive.emit();
        }
      });
    }
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const getAssetBarColumnsCount = () => {
      if (this.relatedProductsCount === 0 && this.firmwareCount !== 0) {
        if (this.documentsCount === 3) {
          return 1;
        }
        return 2;
      }
      if (this.relatedProductsCount === 0) {
        return 4;
      }
      if (this.relatedProductsCount > 0
        && this.relatedProductsCount <= MAX_RELATED_PRODUCTS_FOR_HALF_WIDTH_COLUMN
        && this.firmwareCount !== 0) {
        return 1;
      }
      if (this.relatedProductsCount > 0
        && this.relatedProductsCount <= MAX_RELATED_PRODUCTS_FOR_HALF_WIDTH_COLUMN
        && this.firmwareCount === 0) {
        return 2;
      }
      return this.relatedProductsCount > MAX_RELATED_PRODUCTS_FOR_HALF_WIDTH_COLUMN
        && this.firmwareCount !== 0
        ? 7
        : 1;
    };
    this.assetBar = (_a = tryParse(this._assetBar)) !== null && _a !== void 0 ? _a : this.assetBar;
    this.productRelations = (_b = tryParse(this._productRelations)) !== null && _b !== void 0 ? _b : this.productRelations;
    this.productId = (_c = tryParse(this._productId)) !== null && _c !== void 0 ? _c : this.productId;
    this.tabTitle = (_d = tryParse(this._tabTitle)) !== null && _d !== void 0 ? _d : this.tabTitle;
    this.localeCode = (_e = tryParse(this._localeCode)) !== null && _e !== void 0 ? _e : this.localeCode;
    this.productRelationCustomConfig = (_f = tryParse(this._productRelationCustomConfig)) !== null && _f !== void 0 ? _f : this.productRelationCustomConfig;
    this.documentsCount = ((_h = (_g = this.assetBar) === null || _g === void 0 ? void 0 : _g.documents) === null || _h === void 0 ? void 0 : _h.length) || 0;
    this.firmwareCount = ((_k = (_j = this.assetBar) === null || _j === void 0 ? void 0 : _j.secondaryDocuments) === null || _k === void 0 ? void 0 : _k.length) || 0;
    this.relatedProductsCount = ((_m = (_l = this.productRelations) === null || _l === void 0 ? void 0 : _l.info) === null || _m === void 0 ? void 0 : _m.length) || 0;
    this.assetBarColumnsCount = getAssetBarColumnsCount();
    this.relatedProductsColumnsCount = this.relatedProductsCount
      > MAX_RELATED_PRODUCTS_FOR_HALF_WIDTH_COLUMN
      ? 3 : 2;
    if (window.isApc) {
      this.makeInitialRequests(CircularProductTypes.LINEAR);
    }
    store.dispatch(setLinearProductData({ assetBarRelatedProducts: {
        assetBar: this.assetBar,
        productRelations: this.productRelations,
        productId: this.productId,
        tabTitle: this.tabTitle,
      } }));
    this.unsubscribe = store.subscribe(() => {
      var _a, _b, _c, _d;
      const { data, activeProductTab, lastActionType } = store.getState().product;
      if (lastActionType !== ACTION_TYPES.SET_ACTIVE_PRODUCT_TAB)
        return;
      if (!((_a = data[activeProductTab]) === null || _a === void 0 ? void 0 : _a.assetBarRelatedProducts))
        return;
      const { assetBar, productRelations, productId, tabTitle, } = data[activeProductTab].assetBarRelatedProducts;
      this.assetBar = assetBar;
      this.productRelations = productRelations;
      this.productId = productId;
      this.tabTitle = tabTitle;
      this.documentsCount = ((_b = assetBar === null || assetBar === void 0 ? void 0 : assetBar.documents) === null || _b === void 0 ? void 0 : _b.length) || 0;
      this.firmwareCount = ((_c = assetBar === null || assetBar === void 0 ? void 0 : assetBar.secondaryDocuments) === null || _c === void 0 ? void 0 : _c.length) || 0;
      this.relatedProductsCount = ((_d = productRelations === null || productRelations === void 0 ? void 0 : productRelations.info) === null || _d === void 0 ? void 0 : _d.length) || 0;
      this.assetBarColumnsCount = getAssetBarColumnsCount();
      this.relatedProductsColumnsCount = this.relatedProductsCount
        > MAX_RELATED_PRODUCTS_FOR_HALF_WIDTH_COLUMN
        ? 3 : 2;
      this.updateStickyBarTab();
      if (!window.isApc)
        return;
      const { apcCta, productAvailabilityInfo } = this.initialrequestData[activeProductTab];
      if (!apcCta || !productAvailabilityInfo) {
        this.makeInitialRequests(activeProductTab);
      }
      else {
        this.apcCta = apcCta;
        this.productAvailabilityInfo = productAvailabilityInfo;
      }
    });
  }
  disconnectedCallback() {
    var _a;
    (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  async makeInitialRequests(activeProductTab) {
    try {
      const endPoint = '/products-cta';
      await this.requestApcCta(endPoint, activeProductTab);
      this.requestProductAvailabilityInfo(0, activeProductTab);
    }
    catch (e) {
      throw new Error(e);
    }
  }
  getRelatedProductIds() {
    var _a, _b;
    if ((_b = (_a = this.productRelations) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.length) {
      const relatedProducts = this.productRelations.info
        .map((group) => group.products.map((product) => product.product.name))
        .join('%7C')
        .replace(/,/g, '%7C');
      return relatedProducts;
    }
  }
  getLocaleCodes() {
    const { languageCode, countryCode } = getLocaleFromBody(isBrowser) || {};
    return countryCode && languageCode
      ? join('/', countryCode.toLowerCase(), languageCode)
      : '';
  }
  async requestApcCta(apcCtaUrl, activeProductTab) {
    const { languageCode, countryCode } = getLocaleFromBody(isBrowser) || {};
    const params = {
      countryCode,
      languageCode,
      productId: this.productId,
    };
    this.apcCta = await getApcCta(formCtaUrl(apcCtaUrl, params));
    this.initialrequestData[activeProductTab].apcCta = Object.assign({}, this.apcCta);
  }
  async requestProductAvailabilityInfo(counter, activeProductTab) {
    var _a, _b, _c;
    if ((_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls.apcHost) {
      const requestUrl = availabilityUrl((_c = (_b = this.apcCta) === null || _b === void 0 ? void 0 : _b.urls) === null || _c === void 0 ? void 0 : _c.apcHost, this.getLocaleCodes(), this.getRelatedProductIds());
      try {
        await getAvailabilityInfo(requestUrl).then((res) => {
          if (res === null || res === void 0 ? void 0 : res.prices) {
            this.productAvailabilityInfo = res;
            this.initialrequestData[activeProductTab].productAvailabilityInfo = Object.assign({}, this.productAvailabilityInfo);
            counter = 0;
          }
        }, (err) => {
          if (err && counter < 1) {
            counter++;
            this.requestProductAvailabilityInfo(counter, activeProductTab);
          }
        });
      }
      catch (e) {
        console.log('Error while fetching products prices: ', e);
      }
    }
  }
  updateStickyBarTab() {
    if ((this.documentsCount > 0 || this.relatedProductsCount > 0) && !isMobile()) {
      setStickyBarTab(ETabType.DOCUMENTS, [this.tabTitle]);
    }
    else {
      if (this.documentsCount > 0) {
        setStickyBarTab(ETabType.DOCUMENTS, [this.assetBar.labels.title]);
      }
      if (this.relatedProductsCount > 0) {
        setStickyBarTab(ETabType.COMPATIBLE_PRODUCTS, [
          this.productRelations.relatedProductsBlockLabel,
        ]);
      }
    }
    this.observe();
  }
  componentDidLoad() {
    this.updateStickyBarTab();
  }
  render() {
    return (h("div", { class: "asset-bar-and-related-products-wrapper" }, h("section", { class: "asset-bar-and-related-products" }, this.documentsCount > 0 && (h("section", { ref: (ref) => (this.assetBarRef = ref), class: {
        'asset-bar-and-related-products__column': true,
        'asset-bar-and-related-products__column--asset-bar': true,
        'asset-bar-and-related-products__column--half-width': this.relatedProductsCount <= MAX_RELATED_PRODUCTS_FOR_HALF_WIDTH_COLUMN,
      } }, h("qds-title", { class: "asset-bar-and-related-products__column-header", layer: "main", level: "subsection", alignment: "start" }, this.assetBar.labels.title), h("pes-asset-bar", { documents: this.assetBar.documents, columnsCount: this.assetBarColumnsCount, labels: this.assetBar.labels, secondaryDocuments: this.assetBar.secondaryDocuments }))), this.relatedProductsCount > 0 && (h("section", { ref: (ref) => (this.relatedProductsRef = ref), class: {
        'asset-bar-and-related-products__column': true,
        'asset-bar-and-related-products__column--related-products': true,
        'asset-bar-and-related-products__column--half-width': this.relatedProductsCount <= MAX_RELATED_PRODUCTS_FOR_HALF_WIDTH_COLUMN,
      } }, h("qds-title", { class: "asset-bar-and-related-products__column-header", layer: "main", level: "subsection", alignment: "start" }, this.productRelations.relatedProductsBlockLabel), h("pes-related-products", { items: this.productRelations.info, cartTransferEnabled: this.productRelations.cartTransferEnabled, columnsCount: this.relatedProductsColumnsCount, productId: this.productId, localeCode: this.localeCode, productAvailabilityInfo: this.productAvailabilityInfo, apcCta: this.apcCta, isExternalConsumer: this.isExternalConsumer, productRelationCustomConfig: this.productRelationCustomConfig, ctaInfo: this.productRelations.ctaInfo }))))));
  }
  static get is() { return "pes-asset-bar-and-related-products"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["asset-bar-and-related-products.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["asset-bar-and-related-products.css"]
    };
  }
  static get properties() {
    return {
      "assetBar": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TAssetBarData",
          "resolved": "{ labels: TAssetBarLabels; documents: TAssetBarDocument[]; secondaryDocuments: TAssetBarDocument[]; }",
          "references": {
            "TAssetBarData": {
              "location": "import",
              "path": "../asset-bar/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Data for Asset Bar"
        }
      },
      "_assetBar": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-asset-bar",
        "reflect": false
      },
      "productRelations": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TRelatedProductsData",
          "resolved": "{ addToCartLabel: string; addToFavoritesLabel?: string; cartTransferEnabled: boolean; info: RelatedProductGroup[]; relatedProductsBlockLabel: string; removeFromFavoritesLabel?: string; prpPriceLabel: string; ctaInfo?: TCtaInfo; }",
          "references": {
            "TRelatedProductsData": {
              "location": "import",
              "path": "../asset-bar/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Data for Related Products"
        }
      },
      "_productRelations": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-relations",
        "reflect": false
      },
      "productId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "_productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-id",
        "reflect": false
      },
      "tabTitle": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "tab-title",
        "reflect": false,
        "defaultValue": "'Assets'"
      },
      "_tabTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-tab-title",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "_localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-locale-code",
        "reflect": false
      },
      "apcCta": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TApcCta",
          "resolved": "{ urls: { apcHost: string; }; labels: { addToCartButtonLabel: string; vatLabel: string; inStockLabel: string; authToAddToFavorites: string; removeFromFavorites: string; addToFavorites: string; favorites: string; itemAddedTo: string; signIn: string; createAccount: string; itemRemovedFrom: string; failedResponse: string; }; }",
          "references": {
            "TApcCta": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isAPCSite": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-a-p-c-site",
        "reflect": false
      },
      "apcCtaUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "apc-cta-url",
        "reflect": false
      },
      "productAvailabilityInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductAvailabilityInfo",
          "resolved": "{ howToBuyShowing: { [productId: string]: boolean; }; addToFavoritesInfo: TAddToFavoritesInfo; prices: TPrices; substitution: TSubstitution; factoryStore: TFactoryStore; availability: TAvailability; }",
          "references": {
            "TProductAvailabilityInfo": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false
      },
      "productRelationCustomConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRelatedProductCustomConfig",
          "resolved": "{ showBothProductCtasButton?: boolean; productCtasButtonConfig?: { addToFavoritesLabel?: string; removeFromFavoritesLabel?: string; }; showQuantityColumn?: boolean; quantityColumnConfig?: { label?: string; valueKey?: string; }; }",
          "references": {
            "TRelatedProductCustomConfig": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "_productRelationCustomConfig": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-relation-custom-config",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "setTabActive",
        "name": "setTabActive",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "tabClicked",
        "method": "handleTabClicked",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
